export const ru = {
    more: 'еще'
};
